import './index.less';
import Question from './Question';
Question.install = function(Vue) {
  Vue.component(Question.name, Question);
};

export default Question;
